import { gql } from '@apollo/client';

export const UPDATE_REMOVED_REASON_TEST_SESSION = gql`
  mutation UpdateRemovedReasonTestSession($id: ID!, $removedReason: String) {
    updateRemovedReasonTestSession(id: $id, removedReason: $removedReason) {
      testSession {
        id
      }
    }
  }
`;
